// 用户登录态 store（localStorage 持久化，key 与小程序一致）
import { defineStore } from 'pinia'
import { getToken, getUser, saveLogin as save, clearLogin as clear } from '@/api/request'
import { userApi } from '@/api'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: getToken(),
    userInfo: getUser()
  }),
  getters: {
    isLoggedIn: (s) => !!s.token,
    nickname: (s) => (s.userInfo && s.userInfo.nickname) || '未设置昵称',
    avatarUrl: (s) => (s.userInfo && s.userInfo.avatarUrl) || ''
  },
  actions: {
    saveLogin(token, user) {
      save(token, user)
      this.token = token
      this.userInfo = user
    },
    logout() {
      clear()
      this.token = ''
      this.userInfo = null
    },
    /** 拉取最新用户信息 */
    async fetchUser() {
      try {
        const res = await userApi.info()
        this.saveLogin(this.token, res.data)
        return res.data
      } catch (e) {
        return null
      }
    },
    /** 更新资料（昵称/头像/联系方式） */
    async updateUser(payload) {
      const res = await userApi.update(payload)
      this.saveLogin(this.token, res.data)
      return res.data
    }
  }
})
